<button sdButton type="secondary" fullWidth="true" (click)="openModal()" data-testid="changePickup" tabindex="-1">
  <cx-icon type="POINT"></cx-icon>
  {{ text }}
</button>
